import { useState, useCallback } from 'react';

const useConversationState = () => {
    const [conversationId, setConversationId] = useState(() => {
        const params = new URLSearchParams(window.location.search);
        return params.get("conversationId") || null;
    });
    const [followUpQuestions, setFollowUpQuestions] = useState([]);
    const [conversationHistory, setConversationHistory] = useState([]);
    const [isActivelyStreaming, setIsActivelyStreaming] = useState(false);
    const [streamingAIResponse, setStreamingAIResponse] = useState("");
    const [currentStatus, setCurrentStatus] = useState("");
    const [previewSearchQueries, setPreviewSearchQueries] = useState([]);
    const [previewQueryProducts, setPreviewQueryProducts] = useState([]);
    const [isWaitingForFollowUpQueries, setIsWaitingForFollowUpQueries] = useState(false);
    // Centralized product metadata storage - maps stacklineSku to full product metadata
    const [productMetadataMap, setProductMetadataMap] = useState(new Map());
    // Centralized survey metadata storage - maps campaignId to full survey metadata
    const [surveyMetadataMap, setSurveyMetadataMap] = useState(new Map());
    // Store product group SKUs for streaming (maps group index to array of SKUs)
    const [streamingProductGroups, setStreamingProductGroups] = useState(new Map());
    // Store featured product being streamed (shown above user message during streaming)
    const [streamingFeaturedProduct, setStreamingFeaturedProduct] = useState(null);
    // Store store locator being streamed (shown during streaming)
    const [streamingStoreLocator, setStreamingStoreLocator] = useState(null);
    // Clear all streaming-related state (called when stream completes)
    const clearStreamingState = useCallback(() => {
        setStreamingAIResponse('');
        setPreviewSearchQueries([]);
        setPreviewQueryProducts([]);
        setCurrentStatus('');
        setStreamingFeaturedProduct(null);
        setStreamingStoreLocator(null);
    }, []);
    return {
        conversationId,
        setConversationId,
        conversationHistory,
        setConversationHistory,
        isActivelyStreaming,
        setIsActivelyStreaming,
        streamingAIResponse,
        setStreamingAIResponse,
        currentStatus,
        setCurrentStatus,
        previewSearchQueries,
        setPreviewSearchQueries,
        previewQueryProducts,
        setPreviewQueryProducts,
        isWaitingForFollowUpQueries,
        setIsWaitingForFollowUpQueries,
        productMetadataMap,
        setProductMetadataMap,
        surveyMetadataMap,
        setSurveyMetadataMap,
        streamingProductGroups,
        setStreamingProductGroups,
        followUpQuestions,
        setFollowUpQuestions,
        streamingFeaturedProduct,
        setStreamingFeaturedProduct,
        streamingStoreLocator,
        setStreamingStoreLocator,
        clearStreamingState,
    };
};

export { useConversationState };
//# sourceMappingURL=useConversationState.js.map
